import { Component, OnInit, Input } from '@angular/core';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { AdmService } from 'src/app/service/adm.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-cand-moodel-test',
  templateUrl: './cand-moodel-test.component.html',
  styleUrls: ['./cand-moodel-test.component.scss']
})
export class CandMoodelTestComponent implements OnInit {
  @Input() candData: any;
  showLoader: boolean = false;
  moodelData: any;
  constructor(public globals: Globals,public translate: TranslateService,public admService:AdmService,
    public toastr:ToastrService) { }

  ngOnInit(): void {
    this.getMoodelTest();
  }

  checkDataExist() {
    console.log(this.candData);
    return (typeof this.candData === 'object' && this.candData !== null)
  }

  getMoodelTest() {
    this.showLoader = true;
    let secNumber = 2;
    this.admService.getCandEnglishTest(this.candData.id).subscribe(
      data => {
        this.moodelData = data
        this.moodelData.ieltsFilename = `${environment.API_URL_UTIL}/api/downloadFile/${this.moodelData.ieltsFilename}`;

      },
      error => {
        this.toastr.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        this.showLoader = false;
      },
      () => {
        // console.log("all ques : "+this.questionData);
        this.showLoader = false;
      }
    );
  }
}
